<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  optionLabel="profile.name"
  filterBy="profile.name"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (panelHide)="onPanelHide($event)"
  (openedChange)="openedChange.emit($event)"
  (onFilter)="search($event.filter)"
  [label]="isFloatLabel ? label : ''"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled"
  [itemSubDescriptionField]="itemSubDescriptionField"
  [showClear]="showClear"
  [display]="display"
  [placeholder]="placeholder"
  [sort]="customSearch ? sort : ''"
  [moveDown]="moveDown"
  [loading]="loading || selectionLoading">
  <ng-template
    #itemTemplate
    let-user="item">
    <ng-container *ngIf="toUser(user) as user">
      <div class="flex align-items-center gap-2">
        <div>
          <span [innerHTML]="highlightMatchText(user.profile?.name) | safeHtml"></span>
        </div>
        <div
          *ngIf="user?.banned"
          class="font-medium text-red-500">
          (Заблокирован)
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
